import { Add } from '@mui/icons-material';
import { Autocomplete, Box, Button, InputAdornment, Stack, TextField, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { archLevel } from 'src/data/config';
import { useAppSelector } from 'src/store/hooks';
import SearchIcon from '@mui/icons-material/Search';

interface Props {
  hasCalendarAccess: boolean;
  hasSubjectCalanderVisitAccess: boolean;
  calendarView: string | null;
  viewsList: string[];
  canCreateCalEvent: boolean;
  onViewChange(newView: string | null): void;
  onCreate(isEvent: boolean): void;
  unscheduledVisitPermission: boolean;
}
export default function ScheduleAppBar({
  hasCalendarAccess,
  hasSubjectCalanderVisitAccess,
  calendarView,
  viewsList,
  canCreateCalEvent,
  onViewChange,
  onCreate,
  unscheduledVisitPermission
}: Props) {
  const { t } = useTranslation();
  const currentHierarchyLevel = useAppSelector(state => state.site.currentHierarchyLevel);
  const handleClick = (_: React.MouseEvent<HTMLElement>) => {
    onCreate(true);
  };

  return (
    <Box display="flex" mb={1}>
      {hasSubjectCalanderVisitAccess && (
        <Box display="flex" alignItems="center" flexGrow={1} mr={2}>
          <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
            <Typography>{t('View')}:</Typography>
            <Autocomplete
              id="standard-select-currency-native"
              fullWidth
              disablePortal
              options={viewsList}
              value={calendarView}
              defaultValue={calendarView}
              onChange={(_: any, newValue: string | null) => {
                onViewChange(newValue);
              }}
              renderInput={params => (
                <TextField
                  {...params}
                  variant="standard"
                  placeholder={`Search Subjects`}
                  InputProps={{
                    ...params.InputProps,
                    startAdornment: (
                      <InputAdornment position="start" sx={{ pl: 1 }}>
                        <SearchIcon />
                      </InputAdornment>
                    )
                  }}
                  sx={{ minWidth: '210px' }}
                />
              )}
            />
          </Stack>
        </Box>
      )}
      <Button
        variant="contained"
        size="small"
        disabled={
          archLevel == 'site'
            ? !unscheduledVisitPermission || currentHierarchyLevel !== 'site'
            : !canCreateCalEvent || currentHierarchyLevel !== 'site'
        }
        onClick={handleClick}
        startIcon={<Add />}
        sx={{ ml: 2, mt: 1, height: '32px', fontSize: '13px' }}
      >
        {t('Create Event')}
      </Button>
    </Box>
  );
}
